module.exports = __webpack_public_path__ + "img/download.68f5e9cc.svg";